var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvoiceIconBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.1875,
    y: 0.183594,
    width: 120,
    height: 120,
    rx: 20,
    fill: "#8F4300",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.2473 89.8529L41.6114 107.492L16.6562 34.2436L79.9857 12.1829L101.272 73.2909L92.2473 89.8529Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3691 25.8496L75.5557 26.3815L28.4423 42.793L28.2578 42.2612L75.3691 25.8496Z",
    fill: "#8F4300",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7384 35.5097L78.9229 36.0417L31.8116 52.4531L31.625 51.9214L78.7384 35.5097Z",
    fill: "#8F4300",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1055 45.1699L82.2901 45.7018L35.1788 62.1133L34.9922 61.5815L82.1055 45.1699Z",
    fill: "#8F4300",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4706 54.8302L85.6551 55.362L38.5439 71.7734L38.3594 71.2417L85.4706 54.8302Z",
    fill: "#8F4300",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6524 63.9589L88.8369 64.4909L41.7257 80.9023L41.5391 80.3706L88.6524 63.9589Z",
    fill: "#8F4300",
    fillOpacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.718 97.0014V30.8154H37.3047V104.945C37.3047 106.734 38.7284 108.184 40.4854 108.184H92.7378C98.8016 108.184 103.718 103.177 103.718 97.0014Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.419 108.047C88.8061 107.214 84.5141 102.631 84.5141 97.1001C84.5141 96.409 84.5854 95.7339 84.7133 95.0778H28.3554C28.2275 95.7339 28.1562 96.409 28.1562 97.1001C28.1562 103.221 33.4127 108.184 39.8979 108.184H94.419V108.047Z",
    fill: "#8F4300",
    fillOpacity: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4221 108.055V108.049C88.9412 107.236 84.7184 102.846 84.5234 97.4893C84.7184 102.846 88.9412 107.235 94.4221 108.049V108.055Z",
    fill: "#FDFEFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4241 108.184H92.1932C87.637 106.66 84.3724 102.557 84.3724 97.7348C84.3724 97.0437 84.4437 96.3686 84.5716 95.7125H28.2578C28.2872 95.4993 28.3186 95.2873 28.3605 95.0778H84.7183C84.5905 95.7339 84.5192 96.409 84.5192 97.1001C84.5192 97.2297 84.5213 97.3588 84.5254 97.4874C84.7204 102.844 88.9433 107.234 94.4241 108.047V108.053V108.184Z",
    fill: "#8F4300",
    fillOpacity: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4207 41.6517V42.2148H44.5312V41.6517H94.4207Z",
    fill: "#8F4300",
    fillOpacity: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4207 51.8821V52.4453H44.5312V51.8821H94.4207Z",
    fill: "#8F4300",
    fillOpacity: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4207 62.1126V62.6758H44.5312V62.1126H94.4207Z",
    fill: "#8F4300",
    fillOpacity: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4207 72.3431V72.9062H44.5312V72.3431H94.4207Z",
    fill: "#8F4300",
    fillOpacity: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4207 82.011V82.5742H44.5312V82.011H94.4207Z",
    fill: "#8F4300",
    fillOpacity: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4207 92.2415V92.8047H44.5312V92.2415H94.4207Z",
    fill: "#8F4300",
    fillOpacity: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3011 94.8477L36.9174 93.7192L34.9297 87.8863V51.3665L37.3011 50.5401V60.7776L34.9884 61.5829L35.175 62.1147L37.3011 61.3739V94.8477ZM34.9297 50.7701V40.5327L37.3011 39.7066V49.9438L34.9297 50.7701ZM34.9297 39.9364V27.8809H69.5361L61.1052 30.8177H37.3011V39.1103L34.9297 39.9364ZM86.4734 30.8177H62.8182L71.2491 27.8809H85.4502L86.4734 30.8177Z",
    fill: "#8F4300",
    fillOpacity: 0.3
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9297 40.5312V39.9349L37.3011 39.1088V39.7051L34.9297 40.5312ZM62.8182 30.8163H61.1052L69.5361 27.8794H71.2491L62.8182 30.8163Z",
    fill: "#421F00"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9297 51.3633V50.767L37.3011 49.9407V50.537L34.9297 51.3633Z",
    fill: "#421F00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1788 62.1133L34.9922 61.5815L37.3049 60.7762V61.3725L35.1788 62.1133Z",
    fill: "#421F00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIconBig);
export default __webpack_public_path__ + "static/media/invoice_icon_big.4a4a1fe5748cfe75560495fec354674b.svg";
export { ForwardRef as ReactComponent };